const dataBlog = [
  {
    img: "common-types.svg",
    title: "مقیاس‌پذیری",
    desc: "با تغییر نیازهای کسب‌وکارتان هیچ محدودیتی برای افزایش یا کاهش میزان منابع مورد تقاضای شما وجود ندارد! در ابر «آبالون»، ارتقای حافظه، میزان فضای ذخیره‌سازی، افزایش تعداد پردازنده‌ها و… برای پشتیبانی از کاربران بیشتر، فقط در عرض چند ثانیه بدون هیچ‌گونه وقفه عملیاتی امکان‌پذیر است و این ویژگی، سرورهای ابری «آبالون» را به گزینه‌ای ایده‌آل برای شرکت‌هایی تبدیل می‌کند که در حال رشد هستند.",
    alt: "مقیاس‌پذیری",
  },
  {
    img: "Google.svg",
    title: "اطمینان بالا",
    desc: "سرورهای ابری اتصالی مطمئن، بدون وقفه و با سرعت بالا را برای کاربران فراهم می‌کنند. این سرورها برای به اشتراک گذاشتن قدرت پردازش خود توسط فناوری موسوم به رایانش ابری در استخری از منابع به یکدیگر متصل می‌شوند، در نتیجه مجموعه‌هایی که از زیرساخت‌های ابری برای ارائه خدمات خود استفاده ‌می‌کنند می توانند پایداری و اطمینان صد در صدی را تجربه کنند.",
    alt: "اطمینان بالا",
  },
  {
    img: "everything.svg",
    title: "بهینه‌سازی منابع",
    desc: "با استفاده از سرویس‌های ابری، علاوه بر بهینه‌سازی منابع مالی خود جهت خرید سخت‌افزار و فرآیند پیچیده نگهداری از آن‌ها، تمرکز تیم زیرساخت خود را بر هسته اصلی کسب‌وکار معطوف خواهید کرد و آن‌ها دیگر درگیر مسائل نصب و راه‌اندازی و نگهداری زیرساخت‌های پردازشی نخواهند شد.",
    alt: "بهینه‌سازی منابع",
  },
  {
    img: "python.svg",
    title: "امنیت پیشرفته",
    desc: "با تغییر نیازهای کسب‌وکارتان هیچ محدودیتی برای افزایش یا کاهش میزان منابع مورد تقاضای شما وجود ندارد! در ابر «آبالون»، ارتقای حافظه، میزان فضای ذخیره‌سازی، افزایش تعداد پردازنده‌ها و… برای پشتیبانی از کاربران بیشتر، فقط در عرض چند ثانیه بدون هیچ‌گونه وقفه عملیاتی امکان‌پذیر است و این ویژگی، سرورهای ابری «آبالون» را به گزینه‌ای ایده‌آل برای شرکت‌هایی تبدیل می‌کند که در حال رشد هستند.",
    alt: "وبینار آبالون",
  },
  {
    img: "top-ways.svg",
    title: "انعطاف‌پذیری",
    desc: "با منابعی که نیاز دارید، سریع و آسان شروع کنید! سپس با توجه به نیاز کسب‌وکارتان، تنها با چند کلیک افزایش یا کاهش منابع دهید! بعلاوه، سرورهای ابری می‌توانند با تغییرات سریع برای نیازهای مختلف، بارهای کاری متنوعی را در خود جای دهند. در ابر «آبالون» می‌توانید به راحتی، ویژگی‌های سرور ابری خود را با استفاده از داشبورد مدیریت ابری اختصاصی خود کنترل کنید.",
    alt: "انعطاف‌پذیری",
  },
  {
    img: "Google.svg",
    title: "انعطاف‌پذیری",
    desc: "با منابعی که نیاز دارید، سریع و آسان شروع کنید! سپس با توجه به نیاز کسب‌وکارتان، تنها با چند کلیک افزایش یا کاهش منابع دهید! بعلاوه، سرورهای ابری می‌توانند با تغییرات سریع برای نیازهای مختلف، بارهای کاری متنوعی را در خود جای دهند. در ابر «آبالون» می‌توانید به راحتی، ویژگی‌های سرور ابری خود را با استفاده از داشبورد مدیریت ابری اختصاصی خود کنترل کنید.        ",
    alt: "انعطاف‌پذیری",
  },
];
const benefits = [
  {
    name: "قابلیت انتخاب سطح سرویس",
    logo: "sla.svg",
    alt: "انتخاب سطح سرویس حین خرید سرور ابری",
    title: "انتخاب سطح سرویس حین خرید سرور ابری",
  },
  {
    name: "پشتیبانی 365 / 24 / 7",
    logo: "support.svg",
    alt: "پشتیبانی ۲۴ ساعته سرور ابری",
    title: "پشتیبانی ۲۴ ساعته سرور ابری",
  },
  {
    name: "زیرساخت‌های ایمن",
    logo: "infrustructure.svg",
    alt: "زیرساخت ایمن سرور ابری",
    title: "زیرساخت ایمن سرور ابری",
  },
  {
    name: "داشبورد ابری یکپارچه و جامع ",
    logo: "dashboard.svg",
    alt: "پنل یکپارچه مدیریت سرور ابری",
    title: "پنل یکپارچه سرور ابری",
  },
  {
    name: "کیفیت بالای CPU، RAM و استوریج",
    logo: "hq.svg",
    alt: "کیفیت بالای منابع سرور ابری",
    title: "کیفیت بالای منابع سرور ابری",
  },
  {
    name: "پشتیبانی فنی رایگان",
    logo: "freeSupport.svg",
    alt: "پشتیبانی رایگان سرور ابری آبالون",
    title: "پشتیبانی رایگان سرور ابری آبالون",
  },
];

const questions = [
  {
    title: "سرور ابری چیست؟",
    answer:
      "سرور ابری خارجی یا ایرانی یک سرور مجازی پیشرفته مبتنی بر تکنولوژی رایانش ابری است که زیرساخت یک سرور قدرتمنند را در اختیار شما قرار می‌دهد. با کلود سرور دیگر نیازی به سرور فیزیکی ندارید، در زمان و هزینه صرفه‌جویی می‌کنید و در هر لحظه و از هر مکان به سرور خود دسترسی دارید.",
  },
  {
    title: "تفاوت بین سرور ابری و سرور مجازی چیست؟",
    answer:
      "برخلاف سرورهای مجازی که در آن منابع به صورت اشتراکی در اختیار کاربران قرار می‌گیرد، منابع سرورهای ابری به صورت اختصاصی است و تنها به یک کاربر تخصیص پیدا می‌کنند. علاوه بر این در سرورهای ابری با خرابی هر سخت‌افزار، سرویس به صورت خودکار، در لحظه و بدون قطعی، به سخت‌افزار سالم منتقل می‌شود. سرورهای ابری، بر خلاف سرورهای مجازی امکان افزایش یا کاهش سریع منابع و به میزان بسیار زیاد را نیز فراهم می‌کنند.",
  },
  {
    title: "تفاوت هاست ابری و معمولی چیست؟",
    answer:
      "هاست معمولی یا به عبارتی اشتراکی، منابع یک سرور فیزیکی را در اختیار چندین کاربر قرار می‌دهد. به همین دلیل بر خلاف سرورهای ابری متشکل از تعداد زیادی سرور متصل به هم، یک کاربر می‌‌تواند میزان بسیار زیادی از منابع را استفاده کند و برای سایر کاربران روی آن سرور، مشکل ایجاد نماید. در هاست اشتراکی، همچنین اگر فضای ذخیره‌سازی یکی از کاربران به ویروس یا بدافزار آلوده شود، سرویس‌های سایر کاربران نیز در خطر آلودگی قرار می‌گیرد. افزایش منابع در هاست اشتراکی نیز با محدودیت مواجه است. اما سرورهای ابری هیچ یک از این مشکلات را ندارند و منابع به صورت مجزا و اختصاصی و با امکان افزایش بسیار زیاد در اختیار کاربران قرار می‌گیرند و البته معمولا با قیمت کمی بالاتری ارائه می‌شوند.",
  },
  {
    title: "آیا داده‌های من در سرورهای ابری امن است؟",
    answer:
      "حفظ امنیت داده‌ها در تمامی محصولات و خدمات «آبالون» اولویت اصلی‌ست. در سرورهای کلود نه تنها انتقال داده‌ها رمزگذاری شده، بلکه از ذخیره‌سازی رمزگذاری شده بهره‌مند می‌شوید. علاوه بر این با کمک سرویس کلود گارد آبالون می‌توانید از سرویس‌ها و وب‌سایت خود در مقابل انواع حملات محافظت نمایید.",
  },
  {
    title: "آیا می‌توان سرورهای ابری را بازسازی کرد؟",
    answer:
      "بله. با بازسازی سرور، می‌توانید، بدون نیاز به خرید سرور جدید، سیستم‌عامل دلخواه را انتخاب کنید تا مجدد و در مدت زمان کوتاه روی سرور شما نصب شود. به یاد داشته باشید که بازسازی سرور، اطلاعاتی که روی سیستم‌عامل قبلی داشتید را به‌طور کامل حذف می‌کند.",
  },
  {
    title: "آیا می‌توان حین سرویس، منابع سرورهای ابری را کاهش یا افزایش داد؟",
    answer:
      "بله. منابع سرورهای ابری را می‌توانید حتی حین سرویس کاهش یا افزایش دهید.",
  },
  {
    title: "تفاوت سرورهای ابری خارجی با ایرانی چیست؟",
    answer:
      "هر دو، کیفیت و آپ‌تایم بالایی را ارائه می‌دهند اما خرید سرور ایران در مقایسه با خارجی، هزینه پایین‌تری دارد. سرورهای خارجی با آی‌پی خارج از کشور در اختیار شما قرار می‌گیرد. اگر نیاز دارید خدمات خود را به کاربران خارج از کشور با بالاترین کیفیت و سرعت ارائه دهید، خرید سرور خارجی به شما پیشنهاد می‌شود. در غیر این صورت، خرید سرورهای ایران گزینه بهتری است.",
  },
  {
    title: "آیا می‌توان روی سرورهای ابری وردپرس نصب کرد؟",
    answer:
      " بله. سرورهای ابری آبالون امکان نصب انواع نرم‌افزارهای مدیریت محتوا از جمله وردپرس یا ووکامرس را در اختیارتان می‌گذارد.",
  },
];

const customers = [
  {
    name: "صنایع غذایی",
    title: "گروه سولیکو",
    banner: "/banner-kale.webp",
    banner_title: "Abalon-cloud-server-customer-kale-banner",
    logo_title: "Abalon-cloud-server-customer-kale-logo",
    logo: "/kale.webp",
    logo_gray: "/kale-d.webp",
    description:
      "«گروه سولیکو» با بیش از ۱۵ کارخانه و ۴۰۰ برند از جمله «کاله»، در حوزه صنایع غذایی در ایران فعالیت می‌کند. این شرکت با توجه به حجم بالای پردازش و ذخیره‌سازی خود، در پی سرویسی بود که بتواند از پس تمامی نیازهایش بر آید. دیتاسنتر ابری آبالون توانسته نیازهای ابری سولیکو را پاسخ دهد. اما علاوه بر این لازم بود ارتباط بین استانی شعبات این شرکت با دیتاسنترهای آبالون، به امن‌ترین شکل ممکن، با بالاترین ضریب اطمینان، کاملا جدا از بستر اینترنت و با سرعت بالا فراهم شود. سرویس ویژه «نورونتا» راه حلی است که این ارتباط را برای سولیکو فراهم کرده است.",
    banner_alt: "شرکت سولیکو از مشتریان آبالون",
    logo_alt: "لوگو شرکت سولیکو از مشتریان آبالون",
    logo_gray_alt: "لوگو خاکستری شرکت سولیکو از مشتریان آبالون",
  },
  {
    name: "سازمان‌های امداد رسان",
    title: "هلال احمر",
    banner: "/banner-helal.webp",
    logo: "/helal.webp",
    banner_title: "Abalon-cloud-server-customer-helal-banner",
    logo_title: "Abalon-cloud-server-customer-helal-logo",
    logo_gray: "/helal-d.webp",
    description:
      "سازمان «هلال احمر» برای سامانه «هلال من» نیاز به راه‌اندازی زیرساختی داشت که بخشی از آن روی ابر خصوصی و بخشی دیگر روی ابر عمومی نگهداری شود. علاوه بر این، باید ارتباطات بخش‌های مختلف زیرساخت در نقاط مختلف کشور، از طریق لینک‌های اختصاصی، پرسرعت، امن و مجزا از اینترنت برقرار می‌شد. آبالون با راهکار ابر ترکیبی، معماری مورد نظر این سازمان، شامل ابر خصوصی دیتاسنتر موجود هلال احمر در کنار ابر عمومی آبالون را پیاده‌سازی کرد. همچنین ارتباط بین این دو از طریق لینک‌های پر سرعت نورونتا برقرار شد تا اطمینان حاصل شود، ارتباط، با بالاترین کیفیت و در هر شرایطی ایمن و برقرار باقی می‌ماند.",
    banner_alt: "هلال احمر از مشتریان آبالون",
    logo_alt: "لوگو هلال احمر از مشتریان آبالون",
    logo_gray_alt: "لوگو خاکستری هلال احمر از مشتریان آبالون",
  },
  {
    name: "دانشگاه‌ها و آموزش آنلاین",
    title: "ایسمینار",
    banner: "/banner-eseminar.webp",
    logo: "/eseminar.webp",
    banner_title: "Abalon-cloud-server-customer-eseminar-banner",
    logo_title: "Abalon-cloud-server-customer-eseminar-logo",
    logo_gray: "/eseminar-d.webp",
    description:
      "«ایسمینار»، اولین پلتفرم برگزاری کلاس آنلاین، وبینار و رویدادهای آنلاین ایران، از سال‌های ابتدایی شروع فعالیت خود، زیرساخت‌هایش را روی آبالون بنا کرده است. این پلتفرم نیاز به سرویسی داشت که تنها مبتنی بر یک ماشین مجازی نباشد و بتواند تعداد بالایی از ماشین‌های مجازی را در یک پنل مدیریتی واحد، پیکربندی کند و معماری دلخواه خود را طراحی نماید. سرویس دیتاسنتر ابری آبالون، پاسخی برای نیازهای ایسمینار بود؛ پلتفرمی که حالا به بیش از یک میلیون کاربر خود شامل برگزار کنندگان وبینار و نیز شرکت‌کنندگان، خدمات ارائه می‌دهد. ",
    banner_alt: "ایسمینار از مشتریان آبالون",
    logo_alt: "لوگو ایسمینار از مشتریان آبالون",
    logo_gray_alt: "لوگو خاکستری ایسمینار از مشتریان آبالون",
  },
  {
    name: "صنایع مادر",
    title: "گروه مپنا",
    banner: "/banner-mapna.webp",
    logo: "/mapna.webp",
    banner_title: "Abalon-cloud-server-customer-mapna-banner",
    logo_title: "Abalon-cloud-server-customer-mapna-logo",
    logo_gray: "/mapna-d.webp",
    description:
      "«گروه مپنا» مجموعه‌ای از شرکت‌های صنعتی است که در حوزه‌های مختلف شامل احداث نیروگاه‌ها، تاسیسات تولید برق، اجرای پروژه‌های نفت و گاز، پروژه‌های حمل‌ونقل ریلی و بسیاری زمینه‌های دیگر فعالیت می‌کنند. مپنا در بخش‌‌های متنوعی از فعالیت خود، به زیرساخت‌های آبالون متکی است. یکی از این حوزه‌ها، پردازش‌های ابری مرتبط با سرویس LoRaWAN است که در ماشین‌های مجازی متعدد روی دیتاسنتر ابری آبالون اجرا می‌شود. LoRaWAN یک پروتکل اتصال ارزان‌قیمت، دوربرد و با مصرف انرژی بسیار پایین برای دستگاه‌های اینترنت اشیا (IOT) است که امکان اتصال این دستگاه‌ها به اینترنت و مدیریت و نظارت از راه دور را فراهم می‌کند.",
    banner_alt: "شرکت مپنا از مشتریان آبالون",
    logo_alt: "لوگو شرکت مپنا از مشتریان آبالون",
    logo_gray_alt: "لوگو خاکستری شرکت مپنا از مشتریان آبالون",
  },
];
const uses = [
  {
    img: "disaster.svg",
    name: "بکاپ و بازیابی در شرایط بحرانی",
    desc: "سرور ابری ایران یا خارج،‌ از مطمئن‌ترین و بهترین گزینه‌ها برای پشتیبان‌گیری دوره‌ای و همیشگی از داده‌ها است. با پیاده‌سازی این راهکارها روی کلود سرور می‌‌توانید اطمینان داشته باشید که کسب‌وکار شما همیشه بدون اختلال به فعالیت خود ادامه می‌دهد.",
    alt: "کاربرد سرور ابری در بکاپ و بازیابی در شرایط بحرانی",
    title: "کاربرد سرور ابری در بکاپ و بازیابی دیتا",
  },

  {
    img: "startup.svg",
    name: "بار کاری متغیر استارتاپ‌ها",
    desc: "استارتاپ‌هایی که بار کاری متغیر و دغدغه کاهش هزینه را دارند، با خرید سرور لینوکسی یا ویندوزی می‌توانند در لحظه، منابع را افزایش دهند تا پاسخگوی نیاز مقطعی باشد و از طرف دیگر با کاهش سریع منابع، در هزینه‌های خود صرفه‌جویی کنند.",
    alt: "خرید سرور ابری برای استارتاپ‌ها",
    title: "خرید سرور ابری برای استارتاپ‌ها",
  },
  {
    img: "test.svg",
    name: "محیط مناسب برای آزمون و خطا",
    desc: "یکی از کاربردهای خرید سرور ابری، امکان اجرای آزمون و خطاهای متعدد برای توسعه محصولات و خدمات مختلف است تا بتوانید بدون هیچ دغدغه‌ای روی ایده‌‌ها و طرح‌های خود کار کنید و پتانسیل و سرعت توسعه کسب‌وکار خود را افزایش دهید.",
    alt: "خرید سرور ابری برای محیط آزمون و خطا",
    title: "خرید سرور ابری برای محیط آزمون و خطا",
  },
  {
    img: "backup.svg",
    name: "دسکتاپ مجازی قدرتمند",
    desc: "با خرید سرور ابری ایران یا خارج از دسکتاپ مجازی قدرتمند با نسخه سیستم‌عامل ویندوز یا لینوکس دلخواه‌تان بهره‌مند می‌شوید. دسکتاپ مجازی با آی‌پی اختصاصی در اختیارتان قرار می‌گیرد و می‌توانید همیشه و از هر نقطه جهان به آن دسترسی داشته باشید.",
    alt: "خرید سرور ابری برای دسکتاپ مجازی",
    title: "خرید سرور ابری برای دسکتاپ مجازی",
  },
  {
    img: "service.svg",
    name: "راه اندازی وب‌سایت و سرویس های سازمانی",
    desc: "برای سازمان‌هایی که قصد توسعه محصولات و راه‌اندازی خدمات جدید را دارند، خرید سرور ابری ایران یا خارج با امکان مقیاس‌پذیری سریع منابع در کنار پایداری، آپ‌تایم و کیفیت بالای سرویس از بهینه‌ترین و هوشمندانه‌ترین انتخاب‌هاست.",
    alt: "خرید سرور ابری برای راه‌اندازی وب‌سایت و سرویس‌های سازمانی",
    title: "خرید سرور ابری برای راه‌اندازی وب‌سایت و سرویس سازمانی",
  },
];

const locations = [
  {
    img: "iranServer.svg",
    name: "خرید سرور ابری ایران",
    cap: "خرید سرور کلود ایران نسبت به سرور خارجی هزینه پایین‌تری دارد اما از کیفیت و آپ‌تایم بالایی برخوردار است و زیرساخت‌های آن به پردازنده‌های پر سرعت و استوریج‌های SSD مجهز شده‌ است. خرید سرور کلود ایران، به جهت نزدیکی جغرافیای به کاربران ایرانی، به آن دسته از شرکت‌ها و سازمان‌هایی پیشنهاد می‌شود که قصد دارند سرویس با کیفیت و پر سرعتی را به مخاطبان ایرانی خود ارائه دهند.",
    alt: "خرید سرور ابری ایران",
    title: "خرید سرور ابری ایران",
    class: "iranImg",
  },

  {
    img: "externalServer.svg",
    name: "خرید سرور ابری خارج",
    cap: "سرورهای ابری خارجی در دیتاسنترهای خارج از کشور واقع شده‌اند. خرید سرور ابری خارجی نسبت به سرور کلود ایران قیمت بالاتری دارد و در عین حال کیفیت سرویس و آپ‌تایم بالا را اختیار شما می‌گذارد. خرید سرور ابری خارجی به سازمان‌ها و کسب‌وکارهایی پیشنهاد می‌شود که می‌خواهند خدمات خود را به کاربران خارج از کشور با بالاترین کیفیت و سرعت ارائه دهند یا نیاز به آی‌پی خارجی دارند.",
    alt: "خرید سرور ابری خارجی",
    title: "خرید سرور ابری خارجی",
    class: "externalImg",
  },
];

const PopularServices = [
  {
    title: "دیتاسنتر ابری",
    desc: "دیتاسنتر ابری تمامی قابلیت‌های یک دیتاسنتر فیزیکی را روی ابر برایتان فراهم می‌کند و می‌تواند پاسخی برای پیچیده‌ترین و تخصصی‌ترین نیازهای ابری سازمان شما باشد.",
    logo: "VPC-Service.svg",
    route: "/vpc",
    imgAlt: "دیتاسنتر ابری آبالون",
    imgTitle: "دیتاسنتر ابری آبالون",
  },
  {
    title: "سرویس مدیریت شده",
    desc: "تحت سرویس‌های مدیریت شده، راهکار اختصاصی سازمان شما در حوزه ابری، از جمله نصب سیستم‌عامل و نرم‌افزارها، هاردنینگ، طراحی معماری و مهاجرت ابری، اجرا می‌شود. ",
    logo: "ManagedService-Service.svg",
    route: "/manageServices",
    imgAlt: "سرویس مدیریت شده",
    imgTitle: "سرویس مدیریت شده",
  },
  {
    title: "DNS ابری",
    desc: "با استفاده از DNS ابری بدون نیاز به مدیریت سرورهای DNS، رکوردها و زون‌های DNS همه دامنه‌های خود را مدیریت و در تمام جهان منتشر کرده و سرعت پاسخ‌گویی به کاربران را افزایش دهید.",
    logo: "DNS.svg",
    route: "/dns",
    imgAlt: "DNS ابری آبالون",
    imgTitle: "DNS ابری آبالون",
  },
];
const serviceFeatures = [
  {
    title: "انتخاب سیستم‌عامل دلخواه",
    desc: "در خرید سرورهای ابری، سیستم‌عامل را از بین نسخه‌های مختلف ویندوز یا لینوکس انتخاب کنید.",
    logo: "chooseOs.svg",
    imgAlt: "انتخاب سیستم‌عامل در فرایند خرید سرور ابری",
    imgTitle: "انتخاب سیستم‌عامل در خرید سرور ابری",
  },
  {
    title: "تحویل سرور در یک دقیقه",
    desc: "سرورهای ابری با سیستم‌عامل انتخابی شما در یک دقیقه ایجاد شده و در اختیارتان قرار می‌گیرند.",
    logo: "1minute.svg",
    imgAlt: "تحویل سرور ابری در یک دقیقه",
    imgTitle: "تحویل سرور ابری در یک دقیقه",
  },
  {
    title: "کنسول مدیریتی تحت وب",
    desc: "کنسول مدیریتی سرور حتی با قطع شدن دسترسی سرور به اینترنت امکان اتصال را فراهم می‌کند.",
    logo: "console.svg",
    imgAlt: "کنسول مدیریتی تحت وب کلود سرور",
    imgTitle: "کنسول مدیریتی تحت وب کلود سرور",
  },
  {
    title: "دسترسی از تمام جهان",
    desc: "در هر زمان و از هر نقطه جهان می‌توانید به سرور ابری خارجی یا ایرانی دسترسی داشته باشید.",
    logo: "global.svg",
    imgAlt: "دسترسی به سرور ابری از تمام جهان",
    imgTitle: "دسترسی به سرور ابری از تمام جهان",
  },
  {
    title: "افزایش یا کاهش سریع منابع",
    desc: "با سرورهای ابری آبالون در هر لحظه از سرویس، منابع را افزایش یا کاهش دهید. ",
    logo: "increase.svg",
    imgAlt: "افزایش یا کاهش سریع منابع در سرور ابری",
    imgTitle: "تغییر میزان منابع سرور ابری",
  },
  {
    title: "پشتیبانی ۲۴/۷/۳۶۵",
    desc: "با خرید سرور ابری، از پشتیبانی رایگان همه روزه و در تمامی ساعات شبانه‌روز بهره‌مند شوید.",
    logo: "24.svg",
    imgAlt: "پشتیبانی رایگان ۲۴ ساعته سرور ابری",
    imgTitle: "پشتیبانی رایگان سرور ابری",
  },
  {
    title: "فایروال قابل تنظیم",
    desc: "در تنظیمات فایروال کلود سرور، قوانین دلخواه خود را اضافه و اعمال کنید.",
    logo: "firewall-new.svg",
    imgAlt: "فایروال قابل تنظیم سرور ابری",
    imgTitle: "فایروال قابل تنظیم سرور ابری",
  },
  {
    title: "آپ‌تایم تا ۹۹.۹۹ درصد",
    desc: "سرورهای ابری آبالون با بالاترین میزان آپ‌تایم، تا ۹۹.۹۹ درصد ارائه می‌شوند.",
    logo: "uptime.svg",
    imgAlt: "آپ‌تایم تا ۹۹.۹۹ درصد سرور ابری",
    imgTitle: "آپ‌تایم تا ۹۹.۹۹ درصد سرور ابری",
  },
];
const tabItems = [
  {
    title: "سرور ابری",
    img: "/vps.svg",
    img_deactive: "/vps_d.svg",
    section_title: "سرور ابری",
    caption:
      "سرور ابری آبالون، تمام امکانات یک سرور قدرتمند را روی محیط ابری و تنها در یک دقیقه در اختیارتان قرار می‌دهد. با سرور ابری، از خرید سخت‌افزارهای سرور بی‌نیاز می‌شوید و تنها بر کسب‌وکار خود تمرکز می‌کنید. علاوه بر این، امکان افزایش و کاهش منابع در لحظه، فایروال قابل تنظیم و امکان انتخاب سیستم‌عامل دلخواه را خواهید داشت.",
    contentImg: "/Server-c.svg",
    contentImg_alt: "منوی داشبورد سرور ابری آبالون",
    logo_alt: "مدیریت سرور ابری",
    logo_title: "مدیریت سرور ابری",
    img_alt: "پنل مدیریت سرور ابری",
    img_title: "پنل مدیریت سرور ابری",
  },
  {
    title: "دیتاسنتر ابری",
    img: "/vpc.svg",
    img_deactive: "/vpc_d.svg",
    section_title: "دیتاسنتر ابری",
    caption:
      "دیتاسنتر ابری، همه امکانات یک دیتاسنتر فیزیکی پیشرفته و بزرگ را روی محیط ابر فراهم می‌کند. با دیتاسنتر ابری، هر آنچه را که از زیرساخت قدرتمند تعداد زیادی سرور متصور هستید، بدون هر گونه محدودیت در سخت‌افزار و منابع شبکه، طراحی می‌کنید، می‌سازید و برای همیشه از دغدغه راه‌اندازی و نگهداری تجهیزات سخت‌افزاری دیتاسنترها رها می‌شوید.",
    contentImg: "/data center-c.svg",
    contentImg_alt: "داشبورد اپن استک در سرویس دیتاسنتر ابری آبالون",
    alt: "تعیین محدودیت درخواست",
    logo_alt: "فایروال سرور ابری",
    logo_title: "فایروال سرور ابری",
    img_alt: "تنظیمات فایروال سرور ابری",
    img_title: "فایروال سرور ابری",
  },
  {
    title: "سرویس‌های مدیریت شده ",
    img: "/manageServices.svg",
    section_title: "سرویس‌های مدیریت شده ",
    img_deactive: "/manageServices_d.svg",
    caption:
      "با استفاده از سرویس‌های مدیریت‌ شده، متخصصان فنی و DevOps آبالون به تیم شما اضافه می‌شوند و با تحلیل نیازهای سازمان شما، راهکارهای ابری مورد نیازتان را طراحی، پیاده‌سازی، پشتیبانی و مدیریت می‌کنند. در نتیجه از استخدام نیروهای متخصص حوزه ابر یا آموزش نیروهای فعلی، بی‌نیاز شده و چابک‌تر از قبل بر فرایندهای کسب‌وکار خود تمرکز می‌کنید.",
    contentImg: "/Managedservices-c.svg",
    contentImg_alt: "منوی داشبورد سرویس‌های مدیریت شده آبالون",
    alt: "فایروال وب (WAF)",
    logo_alt: "سرویس‌های مدیریت شده",
    logo_title: "سرویس‌های مدیریت شده",
    img_alt: "سرویس‌های مدیریت شده",
    img_title: "سرویس‌های مدیریت شده",
  },
];
const solotionTabItems = [
  {
    title: "سازمان‌های کوچک",
    img: "/company.svg",
    section_title: "کد زدن و آزمون و خطا از شما، زیرساخت و پشتیبانی از ما!",
    img_deactive: "/company.svg",
    caption: `اگر سازمان شما داده‌های حساسی دارد که مستعد تهدیدهای سایبری، سرقت یا دستکاری اطلاعات است، سرویس کلود گارد آبالون با لایه‌های حفاظتی متعدد، امنیت سرویس‌های شما را تضمین کرده و سرویس‌ها را همیشه در دسترس مخاطبان قرار می‌دهد.`,
    contentImg: "/company-c.svg",
    img_alt: "سازمان",
    img_title: "سازمان",
    logo_alt: "سازمان",
    contentItem: [
      {
        name: "محافظت در مقابل حملات DDoS",
        img: "/ddosProtection.svg",
        alt: "محافظت در مقابل حملات دیداس با کلود گارد",
        title: "محافظت از حملات دیداس با کلود گارد",
      },
      {
        name: "مدیریت تعداد بی نهایت دامنه",
        img: "/infiniteDomain.svg",
        alt: "مدیریت تعداد بی نهایت دامنه در کلود گارد",
        title: "مدیریت بی نهایت دامنه در کلود گارد",
      },
      {
        name: "محدود کردن دسترسی به سرویس‌ها تنها به داخل ایران",
        img: "/limitedAccess.svg",
        alt: "محدود کردن دسترسی به سرویس‌ها تنها به داخل ایران با کلود گارد",
        title: "محدود کردن دسترسی به ایران با کلود گارد",
      },
      {
        name: "امکان استفاده از «امنیت به عنوان سرویس» آبالون جهت ارائه راهکارهای اختصاصی هاردنینگ، دیتا انکریپشن و …",
        img: "/approach.svg",
        alt: "راهکار SECaaS برای ارائه راهکارهای هاردنینگ اختصاصی تحت سرویس کلود گارد",
        title: "راهکار SECaaS کلود گارد",
      },
    ],
  },
  {
    title: "فروشگاه‌های آنلاین",
    img: "/store.svg",
    img_deactive: "/store.svg",
    section_title: "فروشگاه‌های آنلاین",
    caption: `فروشگاه آنلاین شما با کمک کلود گارد آبالون می‌تواند از دسترسی همیشگی به سرویس‌ها بهره‌مند شود. علاوه بر این اطمینان پیدا خواهید کرد که حتی در رویدادهای خاص از جمله اعیاد یا تعطیلات هم وب‌سایت‌تان بدون وقفه به ارائه خدمات ادامه خواهد داد.`,
    contentImg: "/store-c.svg",
    img_alt:
      "فروشگاه آنلاین با امکان دسترسی همیشگی به سرویس‌ها با کمک کلود گارد",
    img_title: "دسترسی همیشگی به فروشگاه آنلاین با کلود گارد",
    logo_alt: "فروشگاه آنلاین",
    contentItem: [
      {
        name: "دسترسی همیشگی حتی حین رویدادهای خاص",
        img: "/uptime.svg",
        alt: "دسترسی همیشگی به سرویس‌های فروشگاه با کلود گارد",
        title: "دسترسی همیشگی به فروشگاه آنلاین با کلود گارد",
      },
      {
        name: "محافظت در مقابل حملات توزیع شده",
        img: "/protection.svg",
        alt: "محافظت در مقابل حملات توزیع شده با کلود گارد",
        title: "محافظت از حملات توزیع شده با کلود گارد",
      },
      {
        name: "بهبود سئو وب‌سایت به لطف شبکه توزیع محتوا",
        img: "/seo.svg",
        alt: "بهبود سئو وب‌سایت با شبکه توزیع محتوای آبالون در کلود گارد",
        title: "بهبود سئو وب‌سایت با کلود گارد",
      },
      {
        name: "صرفه‌جویی در پهنای باند مصرفی سرور",
        img: "/savings.svg",
        alt: "صرفه‌جویی در پهنای باند مصرفی سرور با کلود گارد",
        title: "صرفه‌جویی پهنای باند سرور با کلود گارد",
      },
    ],
  },
  {
    title: "کسب‌وکار",
    img: "/startup.svg",
    img_deactive: "/startup.svg",
    section_title: "کسب‌وکارهای کوچک و استارت‌آپ‌ها‌",
    caption: `استارتاپ شما با سرویس محافظت ابری، از هزینه‌های اولیه و ثانویه ناشی از حملات رها می‌شود و در عین حال در مصرف پهنای باند سرور صرفه‌جویی می‌نماید. علاوه بر این سرویس کلود گارد به شما کمک می‌کند با بهبود رتبه سئو از رقبای خود پیشی بگیرید.`,
    contentImg: "/startup-c.svg",
    img_alt: "مزایای کلود گارد برای کسب‌وکارهای کوچک و استارتاپ‌ها",
    img_title: "کلود گارد برای  استارتاپ‌ها",
    logo_alt: "استارتاپ",
    contentItem: [
      {
        name: "محافظت در مقابل حملات توزیع شده",
        img: "/protection.svg",
        alt: "محافظت در مقابل حملات توزیع شده کلود گارد",
        title: "محافظت از حملات توزیع شده کلود گارد",
      },
      {
        name: "بهبود سئو وب‌سایت به لطف شبکه توزیع محتوا",
        img: "/seo.svg",
        alt: "بهبود سئو وب‌سایت با شبکه توزیع محتوای آبالون",
        title: "بهبود سئو وب‌سایت با شبکه توزیع محتوای آبالون",
      },
      {
        name: "کاهش هزینه پهنای باند مصرفی سرور",
        img: "/reduceCost.svg",
        alt: "کاهش هزینه پهنای باند مصرفی سرور با سرویس کلود گارد",
        title: "کاهش هزینه پهنای باند سرور با کلود گارد",
      },
      {
        name: "محافظت از اطلاعات مشتریان",
        img: "/userInfo.svg",
        alt: "محافظت از اطلاعات مشتریان با فایروال سرویس کلود گارد",
        title: "محافظت از اطلاعات مشتریان با کلود گارد",
      },
    ],
  },
  {
    title: "داده‌های حساس",
    img: "/company.svg",
    section_title: "کد زدن و آزمون و خطا از شما، زیرساخت و پشتیبانی از ما!",
    img_deactive: "/company.svg",
    caption: `اگر سازمان شما داده‌های حساسی دارد که مستعد تهدیدهای سایبری، سرقت یا دستکاری اطلاعات است، سرویس کلود گارد آبالون با لایه‌های حفاظتی متعدد، امنیت سرویس‌های شما را تضمین کرده و سرویس‌ها را همیشه در دسترس مخاطبان قرار می‌دهد.`,
    contentImg: "/company-c.svg",
    img_alt: "سازمان",
    img_title: "سازمان",
    logo_alt: "سازمان",
    contentItem: [
      {
        name: "محافظت در مقابل حملات DDoS",
        img: "/ddosProtection.svg",
        alt: "محافظت در مقابل حملات دیداس با کلود گارد",
        title: "محافظت از حملات دیداس با کلود گارد",
      },
      {
        name: "مدیریت تعداد بی نهایت دامنه",
        img: "/infiniteDomain.svg",
        alt: "مدیریت تعداد بی نهایت دامنه در کلود گارد",
        title: "مدیریت بی نهایت دامنه در کلود گارد",
      },
      {
        name: "محدود کردن دسترسی به سرویس‌ها تنها به داخل ایران",
        img: "/limitedAccess.svg",
        alt: "محدود کردن دسترسی به سرویس‌ها تنها به داخل ایران با کلود گارد",
        title: "محدود کردن دسترسی به ایران با کلود گارد",
      },
      {
        name: "امکان استفاده از «امنیت به عنوان سرویس» آبالون جهت ارائه راهکارهای اختصاصی هاردنینگ، دیتا انکریپشن و …",
        img: "/approach.svg",
        alt: "راهکار SECaaS برای ارائه راهکارهای هاردنینگ اختصاصی تحت سرویس کلود گارد",
        title: "راهکار SECaaS کلود گارد",
      },
    ],
  },
  {
    title: "فروشگاه‌های آنلاین",
    img: "/store.svg",
    img_deactive: "/store.svg",
    section_title: "فروشگاه‌های آنلاین",
    caption: `فروشگاه آنلاین شما با کمک کلود گارد آبالون می‌تواند از دسترسی همیشگی به سرویس‌ها بهره‌مند شود. علاوه بر این اطمینان پیدا خواهید کرد که حتی در رویدادهای خاص از جمله اعیاد یا تعطیلات هم وب‌سایت‌تان بدون وقفه به ارائه خدمات ادامه خواهد داد.`,
    contentImg: "/store-c.svg",
    img_alt:
      "فروشگاه آنلاین با امکان دسترسی همیشگی به سرویس‌ها با کمک کلود گارد",
    img_title: "دسترسی همیشگی به فروشگاه آنلاین با کلود گارد",
    logo_alt: "فروشگاه آنلاین",
    contentItem: [
      {
        name: "دسترسی همیشگی حتی حین رویدادهای خاص",
        img: "/uptime.svg",
        alt: "دسترسی همیشگی به سرویس‌های فروشگاه با کلود گارد",
        title: "دسترسی همیشگی به فروشگاه آنلاین با کلود گارد",
      },
      {
        name: "محافظت در مقابل حملات توزیع شده",
        img: "/protection.svg",
        alt: "محافظت در مقابل حملات توزیع شده با کلود گارد",
        title: "محافظت از حملات توزیع شده با کلود گارد",
      },
      {
        name: "بهبود سئو وب‌سایت به لطف شبکه توزیع محتوا",
        img: "/seo.svg",
        alt: "بهبود سئو وب‌سایت با شبکه توزیع محتوای آبالون در کلود گارد",
        title: "بهبود سئو وب‌سایت با کلود گارد",
      },
      {
        name: "صرفه‌جویی در پهنای باند مصرفی سرور",
        img: "/savings.svg",
        alt: "صرفه‌جویی در پهنای باند مصرفی سرور با کلود گارد",
        title: "صرفه‌جویی پهنای باند سرور با کلود گارد",
      },
    ],
  },
  {
    title: " استارت‌آپ‌ها‌",
    img: "/startup.svg",
    img_deactive: "/startup.svg",
    section_title: "کسب‌وکارهای کوچک و استارت‌آپ‌ها‌",
    caption: `استارتاپ شما با سرویس محافظت ابری، از هزینه‌های اولیه و ثانویه ناشی از حملات رها می‌شود و در عین حال در مصرف پهنای باند سرور صرفه‌جویی می‌نماید. علاوه بر این سرویس کلود گارد به شما کمک می‌کند با بهبود رتبه سئو از رقبای خود پیشی بگیرید.`,
    contentImg: "/startup-c.svg",
    img_alt: "مزایای کلود گارد برای کسب‌وکارهای کوچک و استارتاپ‌ها",
    img_title: "کلود گارد برای  استارتاپ‌ها",
    logo_alt: "استارتاپ",
    contentItem: [
      {
        name: "محافظت در مقابل حملات توزیع شده",
        img: "/protection.svg",
        alt: "محافظت در مقابل حملات توزیع شده کلود گارد",
        title: "محافظت از حملات توزیع شده کلود گارد",
      },
      {
        name: "بهبود سئو وب‌سایت به لطف شبکه توزیع محتوا",
        img: "/seo.svg",
        alt: "بهبود سئو وب‌سایت با شبکه توزیع محتوای آبالون",
        title: "بهبود سئو وب‌سایت با شبکه توزیع محتوای آبالون",
      },
      {
        name: "کاهش هزینه پهنای باند مصرفی سرور",
        img: "/reduceCost.svg",
        alt: "کاهش هزینه پهنای باند مصرفی سرور با سرویس کلود گارد",
        title: "کاهش هزینه پهنای باند سرور با کلود گارد",
      },
      {
        name: "محافظت از اطلاعات مشتریان",
        img: "/userInfo.svg",
        alt: "محافظت از اطلاعات مشتریان با فایروال سرویس کلود گارد",
        title: "محافظت از اطلاعات مشتریان با کلود گارد",
      },
    ],
  },
  {
    title: " داده‌های حساس",
    img: "/company.svg",
    section_title: "کد زدن و آزمون و خطا از شما، زیرساخت و پشتیبانی از ما!",
    img_deactive: "/company.svg",
    caption: `اگر سازمان شما داده‌های حساسی دارد که مستعد تهدیدهای سایبری، سرقت یا دستکاری اطلاعات است، سرویس کلود گارد آبالون با لایه‌های حفاظتی متعدد، امنیت سرویس‌های شما را تضمین کرده و سرویس‌ها را همیشه در دسترس مخاطبان قرار می‌دهد.`,
    contentImg: "/company-c.svg",
    img_alt: "سازمان",
    img_title: "سازمان",
    logo_alt: "سازمان",
    contentItem: [
      {
        name: "محافظت در مقابل حملات DDoS",
        img: "/ddosProtection.svg",
        alt: "محافظت در مقابل حملات دیداس با کلود گارد",
        title: "محافظت از حملات دیداس با کلود گارد",
      },
      {
        name: "مدیریت تعداد بی نهایت دامنه",
        img: "/infiniteDomain.svg",
        alt: "مدیریت تعداد بی نهایت دامنه در کلود گارد",
        title: "مدیریت بی نهایت دامنه در کلود گارد",
      },
      {
        name: "محدود کردن دسترسی به سرویس‌ها تنها به داخل ایران",
        img: "/limitedAccess.svg",
        alt: "محدود کردن دسترسی به سرویس‌ها تنها به داخل ایران با کلود گارد",
        title: "محدود کردن دسترسی به ایران با کلود گارد",
      },
      {
        name: "امکان استفاده از «امنیت به عنوان سرویس» آبالون جهت ارائه راهکارهای اختصاصی هاردنینگ، دیتا انکریپشن و …",
        img: "/approach.svg",
        alt: "راهکار SECaaS برای ارائه راهکارهای هاردنینگ اختصاصی تحت سرویس کلود گارد",
        title: "راهکار SECaaS کلود گارد",
      },
    ],
  },
  {
    title: "فروشگاه‌های آنلاین",
    img: "/store.svg",
    img_deactive: "/store.svg",
    section_title: "فروشگاه‌های آنلاین",
    caption: `فروشگاه آنلاین شما با کمک کلود گارد آبالون می‌تواند از دسترسی همیشگی به سرویس‌ها بهره‌مند شود. علاوه بر این اطمینان پیدا خواهید کرد که حتی در رویدادهای خاص از جمله اعیاد یا تعطیلات هم وب‌سایت‌تان بدون وقفه به ارائه خدمات ادامه خواهد داد.`,
    contentImg: "/store-c.svg",
    img_alt:
      "فروشگاه آنلاین با امکان دسترسی همیشگی به سرویس‌ها با کمک کلود گارد",
    img_title: "دسترسی همیشگی به فروشگاه آنلاین با کلود گارد",
    logo_alt: "فروشگاه آنلاین",
    contentItem: [
      {
        name: "دسترسی همیشگی حتی حین رویدادهای خاص",
        img: "/uptime.svg",
        alt: "دسترسی همیشگی به سرویس‌های فروشگاه با کلود گارد",
        title: "دسترسی همیشگی به فروشگاه آنلاین با کلود گارد",
      },
      {
        name: "محافظت در مقابل حملات توزیع شده",
        img: "/protection.svg",
        alt: "محافظت در مقابل حملات توزیع شده با کلود گارد",
        title: "محافظت از حملات توزیع شده با کلود گارد",
      },
      {
        name: "بهبود سئو وب‌سایت به لطف شبکه توزیع محتوا",
        img: "/seo.svg",
        alt: "بهبود سئو وب‌سایت با شبکه توزیع محتوای آبالون در کلود گارد",
        title: "بهبود سئو وب‌سایت با کلود گارد",
      },
      {
        name: "صرفه‌جویی در پهنای باند مصرفی سرور",
        img: "/savings.svg",
        alt: "صرفه‌جویی در پهنای باند مصرفی سرور با کلود گارد",
        title: "صرفه‌جویی پهنای باند سرور با کلود گارد",
      },
    ],
  },
];

const financialOrganizations = [
  {
    title: "ارائه زیرساخت‌های ابری مورد تایید «سازمان فناوری اطلاعات ایران»",
    color: "#2E6374",
  },
  {
    title:
      "اجرای راهکارهای پشتیبان‌گیری خودکار با امکان بازیابی سریع ناشی از سانحه (DRaaS)",
    color: "#2E6374",
  },
  {
    title:
      "طراحی و پیاده‌سازی راهکارهای امنیتی برای اخذ «مجوز مکنا» یا «گواهینامه افتا»",
    color: "#2E6374",
  },
  {
    title:
      "ارائه زیرساخت قوی برای مدیریت حجم‌های بزرگ داده‌ها و اجرای تحلیل‌های پیچیده",
    color: "#2E6374",
  },
];

const foodOrganizations = [
  {
    title:
      "ارائه زیرساخت ابری برای پلتفرم‌های مدیریت زنجیره تامین مبتنی بر اینترنت اشیا",
    color: "#68475C",
  },
  {
    title:
      "فراهم کردن زیرساخت سریع و قدرتمند و با هر میزان منابع، برای راهکارهای ERP و SCM",
    color: "#68475C",
  },
  {
    title:
      "ارائه زیرساخت مبتنی بر GPU برای تحقیق و توسعه و پیش‌بینی تقاضا به کمک هوش مصنوعی",
    color: "#68475C",
  },
  {
    title:
      "پیاده‌سازی راهکارهای IAM و PAM مبتنی بر ابر جهت مدیریت دسترسی تمامی کاربران",
    color: "#68475C",
  },
];
const parentOrganizations = [
  {
    title:
      "ارتباط امن و مجزا از اینترنت بین دفاتر و کارخانه‌های سازمان و دیتاسنترهای ابری",
    color: "#253F5A",
  },
  {
    title:
      "استفاده از ابزارهای مبتنی بر ابر برای تحلیل داده‌های صنعتی، معدنی و تولیدی",
    color: "#253F5A",
  },
  {
    title:
      "استفاده از زیرساخت‌ ابری برای طراحی و توسعه تکنولوژی‌ها، محصولات و راهکارها",
    color: "#253F5A",
  },
  {
    title: "بهره بردن از زیرساخت ابری برای SCM و مدیریت تجهیزات مبتنی بر IOT",
    color: "#253F5A",
  },
];

const rescureOrganizations = [
  {
    title:
      "فراهم کردن ارتباط امن، ایزوله از بستر اینترنت و در دسترس از سراسر ایران",
    color: "#883E3E",
  },
  {
    title:
      "تضمین آپ‌تایم سرویس تا ٪۹۹.۹۹ برای سرویس‌‌های ابری و نیز خطوط ارتباطی سراسری",
    color: "#883E3E",
  },
  {
    title: "طراحی معماری سرویس‌ها روی ابر عمومی، خصوصی یا ترکیبی",
    color: "#883E3E",
  },
  {
    title:
      "پشتیبانی اختصاصی یکپارچه تمام سرویس‌های ابری و ارتباطی به صورت ۲۴/۷",
    color: "#883E3E",
  },
];
const inovativeOrganizations = [
  {
    title:
      "اجرای مهاجرت از زیرساخت‌های دیگر به زیرساخت‌های ابر عمومی، خصوصی یا ترکیبی",
    color: "#567E4A",
  },
  {
    title:
      "پیاده‌سازی کانتینر ارکستریشن برای خودکارسازی توسعه و نیز اجرای بهینه نرم‌افزار",
    color: "#567E4A",
  },
  {
    title: "اجرای معماری مایکروسرویس برای عملی کردن پیچیده‌ترین راهکارهای ابری",
    color: "#567E4A",
  },
  {
    title:
      "ارائه زیرساخت و ارتباط قوی و ایمن برای مدیریت تجهیزات مبتنی بر اینترنت اشیا",
    color: "#567E4A",
  },
];
const educationOrganizations = [
  {
    title:
      "ارائه زیرساخت قدرتمند و امن برای LMS ،CMS و پورتال‌های دانشجویی و دانش‌آموزی",
    color: "#74682E",
  },
  {
    title:
      "ایجاد زیرساخت قدرتمند برای شبیه‌سازی و مدل‌سازی شبکه عصبی مصنوعی و یادگیری عمیق",
    color: "#74682E",
  },
  {
    title:
      "ارائه زیرساخت سیستم‌های مدیریت منابع انسانی، مالی و عملیات برای پردیس‌های آموزشی",
    color: "#74682E",
  },
  {
    title: "پیاده‌سازی پلتفرم‌های ابری ویدیو کنفرانس و ایمیل ابری",
    color: "#74682E",
  },
];
export default {
  financialOrganizations,
  foodOrganizations,
  parentOrganizations,
  rescureOrganizations,
  inovativeOrganizations,
  educationOrganizations,
  solotionTabItems,
  dataBlog,
  benefits,
  questions,
  uses,
  customers,
  locations,
  PopularServices,
  tabItems,
  serviceFeatures,
};
